module.exports = "<div class=veri-page-header flex=none layout=row> <h1 flex ng-bind=$ctrl.pageTitle></h1> </div> Should be removed ";